import * as React from "react"
import CallTableViewModel from "../../../ViewModels/CallTableViewModel"
import SentimentFiltersViewModel from "./ViewModels/SentimentFiltersViewModel";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import SentimentSlider from "./SentimentSlider";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface ISentimentFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function AgentSentimentFiltersDialog({ open, setOpen, callTableViewModel, setCallTableViewModel }: ISentimentFiltersDialogProps) {
    const [sentimentFilters, setSentimentFilters] = React.useState<SentimentFiltersViewModel>(callTableViewModel.filters.agentSentimentFilters);

    React.useEffect(() => {
        if (open) {
            setSentimentFilters(callTableViewModel.filters.agentSentimentFilters);
        }
    }, [open, callTableViewModel.filters.agentSentimentFilters])

    function handleChangeInput(name: string, value: any) {
        setSentimentFilters({
            ...sentimentFilters,
            [name]: value
        });
    }

    const confirm = () => {
        const newCallTableViewModel = { ...callTableViewModel };

        newCallTableViewModel.filters.agentSentimentFilters = sentimentFilters;
        newCallTableViewModel.filters.agentSentimentFilters.isActive = true;

        setCallTableViewModel({
            ...newCallTableViewModel
        })

        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Agent Sentiment</DialogTitle>
            <DialogContent style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography component="span" variant="h6" fontWeight="bold">Sentiment</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container height="100%">
                            <Grid size={12}>
                                <SentimentSlider
                                    lable="Starting Sentiment"
                                    propertyName="startingSentiment"
                                    enabledValueName="isStartingSentimentEnabled"
                                    sentimentFilters={sentimentFilters}
                                    handleChangeInput={handleChangeInput}
                                    setSentimentFilters={setSentimentFilters}
                                />
                            </Grid>
                            <Grid size={12}>
                                <p style={{ marginTop: '25px' }} />
                            </Grid>
                            <Grid size={12}>
                                <SentimentSlider
                                    lable="Middle Sentiment"
                                    propertyName="middleSentiment"
                                    enabledValueName="isMiddleSentimentEnabled"
                                    sentimentFilters={sentimentFilters}
                                    handleChangeInput={handleChangeInput}
                                    setSentimentFilters={setSentimentFilters}
                                />
                            </Grid>
                            <Grid size={12}>
                                <p style={{ marginTop: '25px' }} />
                            </Grid>
                            <Grid size={12}>
                                <SentimentSlider
                                    lable="Ending Sentiment"
                                    propertyName="finalSentiment"
                                    enabledValueName="isFinalSentimentEnabled"
                                    sentimentFilters={sentimentFilters}
                                    handleChangeInput={handleChangeInput}
                                    setSentimentFilters={setSentimentFilters}
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded={callTableViewModel.filters.agentSentimentFilters.isStartingMoodEnabled || callTableViewModel.filters.agentSentimentFilters.isMiddleMoodEnabled || callTableViewModel.filters.agentSentimentFilters.isFinalMoodEnabled}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography component="span" variant="h6" fontWeight="bold">Mood</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container height="100%">
                            <Grid size={12}>
                                <SentimentSlider
                                    lable="Starting Mood"
                                    propertyName="startingMood"
                                    enabledValueName="isStartingMoodEnabled"
                                    sentimentFilters={sentimentFilters}
                                    handleChangeInput={handleChangeInput}
                                    setSentimentFilters={setSentimentFilters}
                                />
                            </Grid>
                            <Grid size={12}>
                                <p style={{ marginTop: '25px' }} />
                            </Grid>
                            <Grid size={12}>
                                <SentimentSlider
                                    lable="Middle Mood"
                                    propertyName="middleMood"
                                    enabledValueName="isMiddleMoodEnabled"
                                    sentimentFilters={sentimentFilters}
                                    handleChangeInput={handleChangeInput}
                                    setSentimentFilters={setSentimentFilters}
                                />
                            </Grid>
                            <Grid size={12}>
                                <p style={{ marginTop: '25px' }} />
                            </Grid>
                            <Grid size={12}>
                                <SentimentSlider
                                    lable="Ending Mood"
                                    propertyName="finalMood"
                                    enabledValueName="isFinalMoodEnabled"
                                    sentimentFilters={sentimentFilters}
                                    handleChangeInput={handleChangeInput}
                                    setSentimentFilters={setSentimentFilters}
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}
